import React from "react";
import OptionItem from "./OptionItem";
import { OptionsListProps } from "../types";
import PulseLoader from "../../Loader/PulseLoader";

const OptionsList: React.FC<OptionsListProps> = ({
  filteredAndSortedOptions,
  value,
  focusedIndex,
  dropdownId,
  optionClassName,
  searchQuery,
  onOptionToggle,
  onFocusedIndexChange,
  isSearching = false,
  loadingText = "",
  noResultsText = "No results found",
  enableApiSearch = false,
  className,
  selectedOptionClassName,
}) => {
  if (isSearching) {
    return (
      <div className="px-3 py-3 flex items- justify-center gap-2 text-sm text-gray-500 dark:text-gray-400">
        <PulseLoader size={4} />
        {loadingText && <span>{loadingText}</span>}
      </div>
    );
  }

  if (filteredAndSortedOptions.length === 0) {
    const message =
      enableApiSearch && searchQuery.trim()
        ? noResultsText
        : "No options available";

    return (
      <div className="px-3 py-2 text-sm text-gray-500 dark:text-gray-400">
        {message}
      </div>
    );
  }

  return (
    <div className={`py-1 ${className}`}>
      {filteredAndSortedOptions.map((option, index) => (
        <OptionItem
          key={option.value}
          option={option}
          index={index}
          dropdownId={dropdownId}
          isSelected={value.includes(option.value)}
          isFocused={index === focusedIndex}
          isDisabled={option.disabled || false}
          optionClassName={optionClassName}
          onOptionToggle={onOptionToggle}
          onFocusedIndexChange={onFocusedIndexChange}
          selectedOptionClassName={selectedOptionClassName}
        />
      ))}
    </div>
  );
};

export default OptionsList;
